import { RootState } from "../../../store";

export const selectMarkers = (state: RootState) => state.markers.markers;

export const selectFetching = (state: RootState) => state.markers.fetching;

export const selectIsStoryRead = (state: RootState) =>
  state.progress.progress.current_challenge_story_read;
